var map = {
	"./agriculture_1.jpg": "7cb1",
	"./agriculture_info.png": "672d",
	"./autotagging_1.jpg": "5cc0",
	"./autotagging_2.jpg": "bafa",
	"./autotagging_3.jpg": "c4dd",
	"./building_1.jpg": "b882",
	"./cloudplatform_1.png": "5845",
	"./cloudplatform_2.png": "a8db",
	"./cosmetics_1.jpg": "60e3",
	"./cosmetics_info.png": "7812",
	"./dailychemicals_1.jpg": "632c",
	"./foodindustry_1.jpg": "0ca4",
	"./foodsafety_info.png": "4b74",
	"./goodstracing_1.png": "a4ca",
	"./goodstracing_2.jpg": "50d0",
	"./intelligent_info_1.png": "7002",
	"./intelligent_info_process.png": "231b",
	"./intro_1.jpg": "3d7b",
	"./intro_2.jpg": "b0ee",
	"./marketing_info.png": "930d",
	"./marketing_info_2.jpg": "d07f",
	"./pharmaceutical_1.jpg": "5b18",
	"./product_1.png": "b87a",
	"./product_2.png": "5797",
	"./product_3.png": "b4a9",
	"./product_4.png": "332d",
	"./product_5.png": "7c3f",
	"./product_banner.jpg": "229c",
	"./product_banner_bg.png": "f067",
	"./seed_info.png": "5b4c",
	"./system_1.jpg": "70ca",
	"./system_2.jpg": "a7f5",
	"./system_3.jpg": "84dc",
	"./system_4.jpg": "ec4c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f621";